import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';

import { TableConfig, TableConfigUtils } from '@app/shared/util/table-config.utils';

import { ToolReturn } from '@models/tool-return.model';
import { ToolRequestStatus } from "@app/tool/model/enums/tool-request-status.enum";
import { Log } from "ng2-logger";

@Component({
    selector: 'app-tool-returns-table',
    templateUrl: './tool-returns-table.component.html',
    styleUrls: ['./tool-returns-table.component.scss']
})
export class ToolReturnsTableComponent implements OnChanges {
    _logger = Log.create(ToolReturnsTableComponent.name);
    @Input() toolReturns: ToolReturn[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() statusFilters = [];
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = true;
    @Input() isMaterial = false;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() actionClick = new EventEmitter<any>();

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['toolReturns'] && this.toolReturns.length > 0) {
            this.toolReturns = TableConfigUtils.addColorToToolReturnsByPriority(this.toolReturns);
        }
    }

    onPageChange(tableConfig: TableConfig) {
        this._logger.info('onPageChange::', this.tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info('onSortChange::', this.tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info('onFilterChange::', this.tableConfig);
        this.filterChange.emit(tableConfig);
    }

    onActionClick(rowData: any, startProcess: boolean) {
        this._logger.info('onActionClick::', {rowData: rowData, startProcess: startProcess});
        this.actionClick.emit({toolReturn: rowData, startProcess: startProcess});
    }

    isDelivered(toolReturn) {
        return toolReturn.status === ToolRequestStatus.DELIVERED;
    }

    isWaitingForApproval(toolReturn) {
        return toolReturn.status === ToolRequestStatus.WAITING_FOR_APPROVAL;
    }
}
